import React, { PropsWithChildren, useState } from "react";
import { LogCategory } from "Enumerations/LogCategory";
import { useLogging, useToast } from "Shared/Hooks";
import { useRootStore } from "Store/RootStore";
import { ORPCClientContext, createSharedORPCClient } from "./useOPRC";

/**
 * Creates the app's one oRPC client (link, validation plugins, auth headers, telemetry and toast interceptors) and
 * its TanStack Query utils, and shares them with every useORPCClient() / useORPCQuery() call below it.
 * Must be inside RootContextProvider and AppInsightsContext.
 */
export const ORPCClientProvider = ({ children }: PropsWithChildren) => {
    const { startTrackEvent, stopTrackEvent, trackTrace, trackException } = useLogging(LogCategory.Api);
    const auth = useRootStore("AuthStore");
    const appSettings = useRootStore("AppSettingStore");
    const { showToastNotification } = useToast();

    const [shared] = useState(() =>
        createSharedORPCClient({
            auth,
            appSettings,
            logging: { startTrackEvent, stopTrackEvent, trackTrace, trackException },
            showToastNotification
        })
    );

    return <ORPCClientContext value={shared}>{children}</ORPCClientContext>;
};
